<template>
      <BreadCrumb PageTitle=" Liste des reclamations" />

    <ListeReclamation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";

 import ListeReclamation from "@/components/Reclamation/ListeReclamation.vue";

    export default defineComponent({
      name: "ListeReclamationPage",
      components: {
        BreadCrumb,
        ListeReclamation,
      },
    });
  </script>